import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Backdrop, CircularProgress, Container } from "@mui/material";
import CheckoutDeliveryMethod from "../../components/CheckoutDeliveryMethod";
import {
	ApiCallStatus,
	LogisticsMethod
} from "../../utils/constants";
import {
	fetchCheckoutData,
	updateCheckoutData
} from "../PageFunctions/checkoutFunctions";
import { useArgusAuth } from "../../hooks/useArgusAuth";


const CheckoutDeliveryMethodPage = ({
	genericDataLoaded,
	genericPageContent
}) => {
	const {isAuthenticated, isLoading} = useArgusAuth();
	const location = useLocation();
	const navigate = useNavigate();
	const [checkoutData, setCheckoutData] = useState(null);
	const [chosenLogisticsMethod, setChosenLogisticsMethod] = useState(null);

	const [checkoutDataCallStatus, setCheckoutDataCallStatus] = useState(ApiCallStatus.NotStarted);
	const [updateCheckoutDataCallStatus, setUpdateCheckoutDataCallStatus] = useState(ApiCallStatus.NotStarted);

	const gotoLoginPage = () => {
		return navigate("/login", {state: {from: location}});
	};

	const gotoCheckoutShippingAddressPage = () => navigate("/checkout/shipping");
	const gotoCheckoutSummaryPage = () => navigate("/checkout/summary");


	const fetchCheckoutDataAsync = async () => {
		await fetchCheckoutData({
			setCheckoutData,
			setStatusInProgress: () => setCheckoutDataCallStatus(ApiCallStatus.InProgress),
			setStatusSuccess: () => setCheckoutDataCallStatus(ApiCallStatus.Succeeded),
			setStatusFailed: () => setCheckoutDataCallStatus(ApiCallStatus.Failed),
			setStatusError: () => setCheckoutDataCallStatus(ApiCallStatus.Error)
		});
	};

	const updateCheckoutDataAsync = async ({checkoutData}) => {
		await updateCheckoutData({
			checkoutData,
			setStatusInProgress: () => setUpdateCheckoutDataCallStatus(ApiCallStatus.InProgress),
			setStatusSuccess: () => setUpdateCheckoutDataCallStatus(ApiCallStatus.Succeeded),
			setStatusFailed: () => setUpdateCheckoutDataCallStatus(ApiCallStatus.Failed),
			setStatusError: () => setUpdateCheckoutDataCallStatus(ApiCallStatus.Error)
		});
	};

	const authorizedPageLoad = async () => {
		await Promise.all([

		]);
	};

	const unAuthorizedPageLoad = async () => {
		await Promise.all([
			fetchCheckoutDataAsync()
		]);
	};

	useEffect(() => {
		if (genericDataLoaded === true && isLoading === false) {
			if (isAuthenticated === false) {
				gotoLoginPage();
			}
			else {
				authorizedPageLoad();
				unAuthorizedPageLoad();
			}
		}

	}, [genericDataLoaded, isAuthenticated, isLoading]);

	useEffect(() => {
		if (checkoutData?.logisticsMethod) {
			setChosenLogisticsMethod(checkoutData.logisticsMethod);
		}
	}, [checkoutData]);

	useEffect(() => {
		if (updateCheckoutDataCallStatus === ApiCallStatus.Succeeded && !!chosenLogisticsMethod) {
			if (chosenLogisticsMethod === LogisticsMethod.Ship) {
				gotoCheckoutShippingAddressPage();
			}
			else if (chosenLogisticsMethod === LogisticsMethod.Collection) {
				gotoCheckoutSummaryPage();
			}
		}
	}, [updateCheckoutDataCallStatus]);

	const allLoadingStates = [
		checkoutDataCallStatus,
		updateCheckoutDataCallStatus
	];

	const pageIsLoading = allLoadingStates.includes(ApiCallStatus.InProgress) || genericDataLoaded === false || isLoading === true;

	return (
		<Container maxWidth="lg">
			<CheckoutDeliveryMethod
				checkoutData={checkoutData}
				chosenLogisticsMethod={chosenLogisticsMethod}
				setChosenLogisticsMethod={setChosenLogisticsMethod}
				onSubmit={updateCheckoutDataAsync}
			/>
			<Backdrop
				sx={{color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1}}
				open={pageIsLoading}
			>
				<CircularProgress color="inherit"/>
			</Backdrop>
		</Container>
	);
};

export default CheckoutDeliveryMethodPage;
